@import "../../../styles/_media.css";

.outerContainer {
  color: var(--header-text-link-color);
  display: flex;
  flex-direction: column;
  font-family: var(--primary-font-base);
  font-size: var(--header-text-link-fs);
  font-weight: var(--font-weight-regular);
  height: auto;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
}

.miscLinks {
  cursor: pointer;
  padding-bottom: var(--space-xs);
  padding-top: var(--space-xs);
  font-size: var(--font-xxs);
  font-weight: var(--font-weight-bold);
  color: var(--color-gray-20);

  :is(a),
  a:visited {
    color: var(--color-gray-20);
  }
}

.miscNavBorder {
  padding-left: var(--space-xxs);
  padding-right: var(--space-xxs);
  color: var(--color-grey-0);
  font-size: var(--font-md);
  font-weight: var(--font-weight-regular);
  vertical-align: middle;
}

.innerContainer {
  display: flex;
  flex-direction: row;
  height: auto;
  justify-content: space-between;
  margin-bottom: var(--space-sm);
  margin-top: var(--space-md);
  align-items: center;

  @media (--tablet-xl) {
    position: relative;
    margin-top: var(--space-sm);
  }
}

.logo {
  height: var(--header-desktop-logo-height);
  width: var(--header-desktop-logo-width);

  & img {
    height: auto;
    width: 100%;
  }

  @media (--tablet-xl) {
    :is(img) {
      height: 30px;
      width: auto;
    }
  }
}

.quickLinks {
  height: fit-content;
  background-color: var(--header-quicklinks-bg);
  border-top: 2px solid var(--color-bh-dark-blue);
  border-bottom: 3px solid var(--color-grey-5);
  font-size: var(--font-sm);
  font-weight: var(--font-weight-medium);
}

.quickLinksInner {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-right: var(--space-xxl);
  background-color: var(--header-quicklinks-bg);

  @media (--tablet-only) {
    padding-right: var(--space-sm);
  }
}

.topicsListWrapper,
.secTopicsListWrapper {
  height: "100%";

  @media (--tablet-only) {
    overflow-x: scroll;
  }
}

.topicsList,
.secTopicsList {
  display: flex;
  width: fit-content;
  height: 100%;
  align-items: center;
  justify-items: center;
}

.topicLinks {
  max-height: 42px;
  color: var(--primary-text-link);
  cursor: pointer;
  white-space: nowrap;
  font-size: var(--font-sm);
  font-weight: var(--font-weight-medium);
  display: flex;
  align-items: center;
  gap: var(--space-xxs);
  padding-top: var(--space-xs);
  padding-bottom: 12px;
  padding-left: 16px;
  padding-right: 16px;
  align-items: center;
  justify-content: center;

  :is(a) {
    color: var(--primary-text-link);
  }

  &.active,
  a:hover {
    color: var(--primary-text-link-hover-active);
  }
}

.secondaryLinks {
  display: none;
  justify-content: space-between;

  @media (--tablet) {
    display: flex;
  }
}

.miscLists {
  display: flex;
  align-items: center;
}

.secTopicLinks {
  padding: 12px 8px;
  font-size: var(--font-sm);
  font-weight: var(--font-weight-regular);
  color: var(--color-gray-40);
  cursor: pointer;

  :is(a),
  a:visited {
    color: var(--color-gray-40);
  }
}

.headerSearch {
  position: relative;
}

.subscriptionLink {
  margin-right: var(--space-xs);
  display: none;

  @media (--tablet) {
    display: block;
  }
}

.headerSearch {
  display: none;

  @media (--tablet) {
    display: block;
  }
}

.mobileMenu {
  display: none;

  @media (--tablet-xl) {
    display: flex;
    width: 100px;
    height: 42px;
    justify-content: flex-end;
    align-items: center;
  }
}

.hamburgerIcon {
  padding: var(--space-xxs);

  .iconMenu {
    font-size: 28px;
    color: var(--color-gray-10);

    &::before {
      content: "\e80b";
    }
  }
}

.mobileMenuModalOuter {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: block;
  background: var(--color-offwhite);
  z-index: 999;
}

.mobileUserSection {
  position: relative;
  z-index: 49;

  .mysphLogin {
    color: var(--color-gray-40);
    font-weight: var(--font-weight-medium);
  }
}

.mobileMainList {
  padding-left: 24px;

  .mobileMainLinks {
    display: flex;

    :is(a) {
      color: var(--color-gray-40);
      font-size: var(--font-md);
      font-weight: var(--font-weight-bold);
      padding: 12px 16px 12px 24px;
      width: 100%;
    }

    :is(img) {
      width: 20px;
    }
  }
}

.mobileSectionList {
  padding-left: var(--space-md);

  .mobileSectionLinks {
    display: flex;
    height: 42px;
    align-items: center;

    :is(a) {
      width: 100%;
      font-size: var(--font-md);
      font-weight: var(--font-weight-bold);
      padding: 12px 16px 12px 10px;
    }

    :is(img) {
      width: 20px;
    }
  }
}

.mobileMiscList {
  padding-left: 48px;

  .mobileMiscLinks {
    display: flex;

    :is(a) {
      color: var(--color-gray-40);
      font-size: var(--font-md);
      font-weight: var(--font-weight-bold);
      padding: 12px 16px 12px 24px;
      width: 100%;
    }
  }
}

.activeFontTopics {
  color: #ffffff !important;
}

.secTopicWrapper {
  display: flex;
  align-items: center;
  gap: var(--space-xxs);
  padding: 4px 0px;
  max-height: 42px;
}

.icon {
  height: 16px;
}
